import { Badge, OverlayTrigger, Stack } from "react-bootstrap";
import { INotificationListItemProps } from "./NotificationsCard.types";
import { isMobile } from "react-device-detect";
import { isNullOrUndefined } from "../../../shared/utils/data.utils";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import CardUtils from "../Card.utils";
import NotificationsStyles from "./NotificationsCard.styles";
import React, { useEffect, useState } from "react";
import TOOL_TIP from "../../tooltip/ToolTip.component";

const NOTIFICATION_LIST_ITEM: React.FC<INotificationListItemProps> = (
  props: INotificationListItemProps
) => {
  const { notification } = props;

  const sendDataToGTM = useGTMDispatch();
  const [badgeColorFlag, setBadgeColorFlag] = useState<string | undefined>();
  const [badgeLabel, setBadgeLabel] = useState<string | undefined>();
  const [addressText, setAddressText] = useState<string | undefined>();

  useEffect(() => {
    const addressParts: string[] = [];
    /* istanbul ignore next */
    if (notification) {
      if (notification.status?.name) {
        const { colorFlag, label } = CardUtils.getBadgeFormat(
          notification.status?.name ?? ""
        );
        setBadgeColorFlag(colorFlag);
        setBadgeLabel(label);
      }

      if (!isNullOrUndefined(notification.address)) {
        addressParts.push(notification.address);
      }
      if (!isNullOrUndefined(notification.city)) {
        addressParts.push(notification.city);
      }
      if (!isNullOrUndefined(notification.county)) {
        addressParts.push(notification.county);
      }
    }

    const text =
      addressParts.length > 0
        ? addressParts.reduce((x, y) => x + " | " + y)
        : "";

    setAddressText(text);
  }, [addressText, notification]);

  return (
    <NotificationsStyles.NotificationListItem
      className="notification-stack-item"
      direction="horizontal"
      gap={2}
    >
      <Stack>
        <span className="type">{notification.notificationType}</span>
        <span className="description">
          {notification.notificationDescription}
        </span>
        <span className="address">{addressText}</span>
        <span className="id">{notification.notificationId}</span>
      </Stack>
      <div className="ms-auto">
        <OverlayTrigger
          trigger="click"
          rootClose
          transition
          placement={/* istanbul ignore next */ isMobile ? "bottom" : "left"}
          onToggle={
            /* istanbul ignore next */ (nextShow: boolean) => {
              if (nextShow) {
                sendDataToGTM({
                  event: "eventTracking",
                  category: "Construction",
                  action: `Tooltip Opened - ${badgeLabel} Badge`,
                  label: "Notification Badge",
                });
              }
            }
          }
          overlay={TOOL_TIP({
            packageStatus:
              /* istanbul ignore next */ notification.status?.name ?? "",
          })}
        >
          <Badge className="badge-tooltip" bg={badgeColorFlag}>
            {badgeLabel}
          </Badge>
        </OverlayTrigger>
      </div>
    </NotificationsStyles.NotificationListItem>
  );
};

export default NOTIFICATION_LIST_ITEM;
